export default __webpack_public_path__ + "static/media/oscer-pres-mouth-bleeding.44c5dc3e.svg";